export const EXPLORE_SCHOOLS_TOKEN = `avlplacementIdsCommaSeparated`;
export const LOGIN_PREFILL_TOKEN_PARAM = "tk";
